import { AppTopBar } from '../AppTopBar';

export function OriginatorTopBar() {
  return (
    <AppTopBar
      homeTo="/"
      homeAriaLabel="UMB eVault — Originator home"
    />
  );
}
